<template>
  <div v-if="filterDefinition.filterTypeName === 'radio'">
    <label class="xradio">
      {{ filterOption.name }}
      <input
        type="radio"
        :name="'radio' + filterDefinition.queryParameter"
        :checked="filterOption.checked"
        v-on:input="selectFilter($event, filterOption, filterDefinition)"
      />
      <span></span>
    </label>
  </div>
  <div v-else-if="filterDefinition.filterTypeName === 'checkbox'">
    <label class="xcheck">
      {{ filterOption.label || filterOption.name }}
      <input
        type="checkbox"
        :name="'checkbox' + filterDefinition.queryParameter"
        :checked="filterOption.checked"
        v-on:input="selectFilter($event, filterOption)"
      />
      <span></span>
    </label>
  </div>
  <div v-else-if="filterDefinition.filterTypeName === 'select'">
    <select @change="handleSelectChange($event)">
      <option
        v-for="(item, itemIndex) in filterOptions"
        :key="itemIndex"
        :value="item.id"
        :selected="item.checked"
      >
        {{ item.label || item.name }}
      </option>
    </select>
  </div>
  <div v-else></div>
</template>
<script setup lang="ts">
import { PropType, computed } from "vue";
import { FilterDefinition, FilterOption } from "@/types/search-page";
import { useSearchPageStore } from "@/store/store/searchPageStore";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  filterDefinition: {
    type: Object as PropType<FilterDefinition>,
    required: true,
  },
  filterOption: {
    type: Object as PropType<FilterOption>,
    required: true,
  },
  showAllFilterOptions: {
    type: Boolean,
    default: false,
  },
});

const filterOptions = computed(() => {
  if (props.filterDefinition.maxVisibleOptions && !props.showAllFilterOptions) {
    return searchPageStore
      .filteredSectionResults(props.filterDefinition)
      .slice(0, props.filterDefinition.maxVisibleOptions);
  }

  if (props.showAllFilterOptions) {
    return searchPageStore.filteredSectionResults(props.filterDefinition);
  }

  return props.filterDefinition.options;
});

const handleSelectChange = (event, filterSingle?: any) => {
  if (!event.target) return;
  const selectedValue = event.target.value;
  const selectedItem =
    filterSingle.options.find((item) => item.id == selectedValue) || null;
  searchPageStore.selectFilter(event, selectedItem, filterSingle);
};

function selectFilter(
  event: Event,
  input: FilterOption,
  parent?: FilterDefinition
) {
  searchPageStore.selectFilter(event, input, parent);
}
</script>

<style scoped src="@/assets/css/search-page/search-page.css"></style>
